import React, { Fragment } from "react";
import { Container, Row, Col, Card, Button} from "react-bootstrap";
import { Link } from "react-router-dom";


const Tldllv = () => { 

  return( 
    <Fragment>

      <div className="bg-light mx-0 my-0 p-5 rounded-lg" >
        <h1>Resources for Leaders</h1>
        <p className="lead"> Worksheets accompanying <em>Think Like A Disrupter, Lead Like A Visionary</em>.</p>
      </div> 

      <Container fluid className="p-5">
         <Row className="mb-5">
            <Col className="col-12 col-md-4 mb-3">
               <img className="card-img-top img-fluid"
                     src="/images/hackingCreativity/TLDLLVCoverPage.png"
                     height="100%"
                     width = "100%"
                     alt="TLDLLV"
               />
            </Col>
            <Col className="col-12 col-md-8 mb-3">
               <h4> Think Like A Disrupter, Lead Like A Visionary </h4>
               <p className="lead">A Personal Action Guide For Executives To Ignite Innovation</p>

               <p>
               This book outlines key skills that business leaders must build in order to create more innovative companies. Each chapter focuses on a specific skill and includes worksheets for leaders to practice the skill. 
               </p>
               <p>
               Use the links below to download worksheets from the book.   
               </p>

               <p>
                  Order the book from <Link to="https://www.amazon.com/Think-Like-Disrupter-Lead-Visionary/dp/B0D7Y17FTQ" target="_blank"> Amazon</Link>.  
               </p>
               
            </Col>
            
         </Row>
         <Row className="mb-3">
            <Col className="col-12 col-md-3 mb-3">
               <Card className="border-info">      
                  <Card.Body>
                     <Card.Title>
                        Entrepreneurial Mindset
                     </Card.Title>
                     <Card.Text className="small">
                        Entrepreneurial Mindset is a cognitive perspective that allows individuals to identify opportunities and stay adaptable. 
                     </Card.Text>
                     <Link to="/docs/hackingCreativity/TLDLLV/EntrepreneurialMindsetWorksheets.pdf" target="_blank">
                        <Button> Download </Button>
                     </Link>
                  </Card.Body>     
               </Card>
            </Col>

            <Col className="col-12 col-md-3 mb-3">
               <Card className="border-info">      
                  <Card.Body>
                     <Card.Title>
                        The Power Of Small 
                     </Card.Title>
                     <Card.Text className="small">
                        Doing simple acts of creativity, like changing a team meeting format or a workflow process, build up your creative muscle. 
                     </Card.Text>
                     <Link to="/docs/hackingCreativity/TLDLLV/EverydayCreativityWorksheets.pdf" target="_blank">
                        <Button> Download </Button>
                     </Link>
                  </Card.Body>     
               </Card>
            </Col>

            <Col className="col-12 col-md-3 mb-3">
               <Card className="border-info">      
                  <Card.Body>
                     <Card.Title>
                        Connecting The Dots
                     </Card.Title>
                     <Card.Text className="small">
                        Associative thinking, or the ability to connect seemingly unrelated ideas, is the cornerstone of many inventions. 
                     </Card.Text>
                     <Link to="/docs/hackingCreativity/TLDLLV/AssociativeThinkingWorksheets.pdf" target="_blank">
                        <Button> Download </Button>
                     </Link>
                  </Card.Body>     
               </Card>
            </Col>

            <Col className="col-12 col-md-3 mb-3">
               <Card className="border-info">      
                  <Card.Body>
                     <Card.Title>
                        Rethinking The Obvious
                     </Card.Title>
                     <Card.Text className="small">
                        Assumptions are like mental roadblocks. Reversing them can spark new insights and disruptive ideas. 
                     </Card.Text>
                     <Link to="/docs/hackingCreativity/TLDLLV/ChallengingAssumptionsWorksheets.pdf" target="_blank">
                        <Button> Download </Button>
                     </Link>
                  </Card.Body>     
               </Card>
            </Col>

         </Row>

         <Row>
            <Col className="col-12 col-md-3 mb-3">
               <Card className="border-info">      
                  <Card.Body>
                     <Card.Title>
                        Embracing Humility
                     </Card.Title>
                     <Card.Text className="small">
                        Humility isn't about being self-deprecating but being clear eyed about your strenghts and weaknesses. 
                     </Card.Text>
                     <Link to="/docs/hackingCreativity/TLDLLV/HumilityWorksheets.pdf" target="_blank">
                        <Button> Download </Button>
                     </Link>
                  </Card.Body>     
               </Card>
            </Col>

            <Col className="col-12 col-md-3 mb-3">
               <Card className="border-info">      
                  <Card.Body>
                     <Card.Title>
                        Active Listening
                     </Card.Title>
                     <Card.Text className="small">
                        Active Listening is a cognitive skill with an end goal of changing your's or the other's internal mental models. 
                     </Card.Text>
                     <Link to="/docs/hackingCreativity/TLDLLV/ActiveListeningWorksheets.pdf" target="_blank">
                        <Button> Download </Button>
                     </Link>
                  </Card.Body>     
               </Card>
            </Col>  

            <Col className="col-12 col-md-3 mb-3">
               <Card className="border-info">      
                  <Card.Body>
                     <Card.Title>
                        Cognitive Empathy
                     </Card.Title>
                     <Card.Text className="small">
                        Cognitive empathy involves understanding another person's perspective through conscious reasoning. 
                     </Card.Text>
                     <Link to="/docs/hackingCreativity/TLDLLV/CognitiveEmpathyWorksheets.pdf" target="_blank">
                        <Button> Download </Button>
                     </Link>
                  </Card.Body>     
               </Card>
            </Col>

            <Col className="col-12 col-md-3 mb-3">
               <Card className="border-info">      
                  <Card.Body>
                     <Card.Title>
                        Collective Genius
                     </Card.Title>
                     <Card.Text className="small">
                        Collective genius arises from very specific conditions, independence of thought among members being a key one. 
                     </Card.Text>
                     <Link to="/docs/hackingCreativity/TLDLLV/GroupIntelligenceWorksheets.pdf" target="_blank">
                        <Button> Download </Button>
                     </Link>
                  </Card.Body>     
               </Card>
            </Col>

         </Row>

         


      </Container>

    </Fragment>
       
  );
};
  
export default Tldllv;